import React from 'react';
import { FaLinkedin, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

 const Popup = ({ speaker, onClose }) => {
    
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="max-w-xl p-5 bg-white rounded shadow-lg max-h-screen overflow-y-auto">
        <div className="flex justify-end">
        <button
  className="text-gray-500 hover:text-gray-700 focus:outline-none rounded-full bg-transparent border-2 border-gray-500 p-2 transition-colors duration-300 hover:bg-green-500"
  onClick={onClose}
>
  <svg
    className="w-4 h-4 fill-current"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M10 8.586L15.95 2.636a1 1 0 011.414 1.414L11.414 10l5.95 5.95a1 1 0 01-1.414 1.414L10 11.414l-5.95 5.95a1 1 0 01-1.414-1.414L8.586 10 2.636 4.05A1 1 0 014.05 2.636L10 8.586z"
      clipRule="evenodd"
    ></path>
  </svg>
</button>



        </div>
        <div className="h-full overflow-y-auto">
          <img className="w-full" src={speaker.image} alt={speaker.name} />
          <div className="px-6 py-4">
            <div className="font-bold text-2xl mb-3">{speaker.name}</div>
            <p className=" font-bold text-black text-base mb-2">{speaker.description}</p>
            <p className="text-gray-700 text-lg mb-2 text-left">{speaker.fulldec}</p>
            <div className="mt-4 flex justify-center">
              <a
                href={speaker.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <FaLinkedin size={32} />
              </a>
              <a
                href={speaker.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <FaFacebook size={32} />
              </a>
              <a
                href={speaker.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <FaInstagram size={32} />
              </a>
              <a
                href={speaker.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <FaTwitter size={32} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Popup };
